// extracted by mini-css-extract-plugin
module.exports = {"table":"BranchTable_table__1aGVD"};